import React, { useState } from 'react';
import { Card, Badge, Modal, Button } from 'react-bootstrap';
import moment from 'moment';

const EVENTO_CONFIG = {
  creada: { icon: '📝', color: 'secondary', label: 'Creada' },
  editada: { icon: '✏️', color: 'info', label: 'Editada' },
  enviada: { icon: '📤', color: 'primary', label: 'Enviada' },
  vista: { icon: '👁️', color: 'primary', label: 'Vista' },
  aprobada: { icon: '✅', color: 'success', label: 'Aprobada' },
  rechazada: { icon: '❌', color: 'danger', label: 'Rechazada' },
  cambios_solicitados: { icon: '⚠️', color: 'warning', label: 'Cambios Solicitados' },
  cambios_procesados: { icon: '🔄', color: 'info', label: 'Cambios Procesados' },
  vencida: { icon: '⏰', color: 'warning', label: 'Vencida' },
  facturada: { icon: '💰', color: 'dark', label: 'Facturada' },
  reactivada: { icon: '🔁', color: 'success', label: 'Reactivada' },
  version_creada: { icon: '📋', color: 'secondary', label: 'Versión Creada' },
  autorizada: { icon: '✔️', color: 'info', label: 'Autorizada' },
};

const TimelinePropuesta = ({ timeline = [] }) => {
  const [expandido, setExpandido] = useState(false);
  const [evidenciaModal, setEvidenciaModal] = useState(null);
  const esPdf = (url) => /\.pdf(\?|$)/i.test(url || '');

  if (!timeline || timeline.length === 0) {
    return null;
  }

  const eventos = expandido ? timeline : timeline.slice(0, 5);

  const getActorNombre = (actor) => {
    if (!actor) return 'Sistema';
    if (actor.nombreExterno) return actor.nombreExterno;
    if (actor.usuarioId?.nombre) return actor.usuarioId.nombre;
    return actor.tipo || 'Sistema';
  };

  return (
    <Card className="mt-3 w-100">
      <Card.Header className="w-100 d-flex justify-content-between align-items-center" 
        style={{ cursor: 'pointer' }} onClick={() => setExpandido(!expandido)}>
        <h6 className="mb-0">Historial de Eventos ({timeline.length})</h6>
        <span>{expandido ? '▲' : '▼'}</span>
      </Card.Header>
      <Card.Body style={{ padding: '0' }} className='w-100'>
        <div style={{ position: 'relative', paddingLeft: '30px' }}>
          {eventos.map((evento, index) => {
            const config = EVENTO_CONFIG[evento.evento] || { icon: '•', color: 'secondary', label: evento.evento };
            return (
              <div key={index} style={{
                position: 'relative',
                padding: '12px 15px',
                borderBottom: index < eventos.length - 1 ? '1px solid #e9ecef' : 'none'
              }}>
                <div style={{
                  position: 'absolute',
                  left: '-20px',
                  top: '14px',
                  fontSize: '16px'
                }}>
                  {config.icon}
                </div>
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    <Badge bg={config.color} className="me-2">{config.label}</Badge>
                    <small className="text-muted">{getActorNombre(evento.actor)}</small>
                    {evento.descripcion && (
                      <p className="mb-0 mt-1 text-muted" style={{ fontSize: '0.85rem' }}>
                        {evento.descripcion}
                      </p>
                    )}
                    {evento.evento === 'creada' && evento.metadata?.origen && (
                      <p className="mb-0 mt-1" style={{ fontSize: '0.82rem' }}>
                        <Badge bg="secondary" className="me-1">Origen</Badge>
                        {evento.metadata.origen}
                        {evento.metadata.evidenciaFile && (
                          <a href={evento.metadata.evidenciaFile} target="_blank" rel="noreferrer" className="ms-2">
                            <i className="bi bi-paperclip"></i> Ver evidencia
                          </a>
                        )}
                      </p>
                    )}
                    {evento.evento === 'editada' && evento.metadata?.tipoEdicion === 'cliente' && evento.metadata.evidenciaFile && (
                      <p className="mb-0 mt-1" style={{ fontSize: '0.82rem' }}>
                        <Badge bg="info" className="me-1">Solicitada por cliente</Badge>
                        <a
                          href="#"
                          onClick={(e) => { e.preventDefault(); setEvidenciaModal(evento.metadata.evidenciaFile); }}
                        >
                          <i className="bi bi-paperclip"></i> Ver evidencia
                        </a>
                      </p>
                    )}
                    {evento.evento === 'editada' && evento.metadata?.tipoEdicion === 'interna' && (
                      <p className="mb-0 mt-1" style={{ fontSize: '0.82rem' }}>
                        <Badge bg="secondary">Edición interna</Badge>
                      </p>
                    )}
                  </div>
                  <small className="text-muted" style={{ whiteSpace: 'nowrap' }}>
                    {moment(evento.fecha).format('DD/MM/YYYY HH:mm')}
                  </small>
                </div>
              </div>
            );
          })}
        </div>
        {timeline.length > 5 && !expandido && (
          <div className="text-center py-2">
            <small className="text-primary" style={{ cursor: 'pointer' }}
              onClick={() => setExpandido(true)}>
              Ver {timeline.length - 5} eventos más
            </small>
          </div>
        )}
      </Card.Body>

      <Modal show={!!evidenciaModal} onHide={() => setEvidenciaModal(null)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Evidencia del cambio</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          {evidenciaModal && (
            esPdf(evidenciaModal) ? (
              <iframe
                src={evidenciaModal}
                title="Evidencia"
                style={{ width: '100%', height: '70vh', border: 0 }}
              />
            ) : (
              <img
                src={evidenciaModal}
                alt="Evidencia"
                style={{ maxWidth: '100%', maxHeight: '70vh' }}
              />
            )
          )}
        </Modal.Body>
        <Modal.Footer>
          {evidenciaModal && (
            <a
              href={evidenciaModal}
              target="_blank"
              rel="noreferrer"
              className="btn btn-outline-primary"
            >
              Abrir en nueva pestaña
            </a>
          )}
          <Button variant="secondary" onClick={() => setEvidenciaModal(null)}>Cerrar</Button>
        </Modal.Footer>
      </Modal>
    </Card>
  );
};

export default TimelinePropuesta;
